var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-checkbox',{attrs:{"icon":'icon-success',"checked":_vm.item.Selected,"disabled":_vm.item.Disabled}},[_vm._t("default",[_vm._v(_vm._s(_vm.item.Value))],null,_vm.item.Value)],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-514707da","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ui-components/~/list-view/src/ui-list-view-item-check.vue
// module id = 703
// module chunks = 0